"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initErrorHandler = void 0;
var ERROR_CSS_CLASS = 'highlightError';
var ERRORS = [{
  message: 'The provided credentials are incorrect',
  fieldId: 'signInName'
}, {
  message: 'The provided credentials are incorrect',
  fieldId: 'password'
}, {
  message: 'Missing required element: Country',
  fieldId: 'combinedLocation'
}, {
  message: 'The password entry fields do not match',
  fieldId: 'newPassword'
}, {
  message: 'A user with the specified e-mail address already exists',
  fieldId: 'email'
}];
var mapErrorFieldByErrorMessage = function mapErrorFieldByErrorMessage(errorMessage) {
  var _a;
  var errorField = ERRORS.filter(function (error) {
    return errorMessage.includes(error.message);
  });
  return (_a = errorField[0]) === null || _a === void 0 ? void 0 : _a.fieldId;
};
var createPageErrorFieldMutationObserver = function createPageErrorFieldMutationObserver(errorField) {
  return new MutationObserver(function () {
    ERRORS.forEach(function (error) {
      var field = document.getElementById(error.fieldId);
      if (field) {
        field.classList.remove(ERROR_CSS_CLASS);
      }
    });
    if (errorField.style.display !== 'none') {
      var errorFieldId = mapErrorFieldByErrorMessage(errorField.innerText);
      var newErrorField = document.getElementById(errorFieldId);
      if (errorFieldId && newErrorField) {
        newErrorField.classList.add(ERROR_CSS_CLASS);
      }
    }
  });
};
var initErrorHandler = function initErrorHandler() {
  document.querySelectorAll('.error.pageLevel').forEach(function (errorField) {
    createPageErrorFieldMutationObserver(errorField).observe(errorField, {
      attributes: true,
      childList: true
    });
  });
};
exports.initErrorHandler = initErrorHandler;
//# sourceMappingURL=errorHander.js.map